import KendoDateAndOrTimePicker from '@/Components/KendoDateTimePicker/Controls/KendoDateAndOrTimePickerBase';
import ComponentManager from '@/Management/ComponentManager';
import KendoDateAndTimePickerViewModelType from '@/Components/KendoDateTimePicker/ViewModels/KendoDateAndTimePickerViewModel';
import LinkType from '@/Controls/Link';
import ResourceManager from '@/Management/ResourceManager';

export default class KendoDateAndTimePicker extends KendoDateAndOrTimePicker {

    private Link = ComponentManager.getControl<typeof LinkType>('Link');
    private linkDate: LinkType;
    private linkTime: LinkType;

    /**
     * @override
     */
    public widget: KnockoutObservable<kendo.ui.DateTimePickerExt>;

    public constructor(protected viewModel: KendoDateAndTimePickerViewModelType, protected element?: JQuery) {
        super(viewModel, element);
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.createControl(this.element, '<div class="c-wrapper"><input type="text"></div>');

        let language = ResourceManager.getInstance().getLanguage();

        this.applyBindings(this.jQueryControl.find('input'), {
            kendoDateTimePicker: {
                animation: this.viewModel.animation,

                value: this.viewModel.date,

                culture: language.cultureInfoName,

                min: this.viewModel.min,

                max: this.viewModel.max,

                format: this.definePureComputed({
                    read: () => {
                        return language.datePattern + ' ' + language.timePattern;
                    }
                }),

                widget: this.widget
            },

            tooltip: this.viewModel.tooltip,

            focus: this.viewModel.isFocusable,

            attr: {
                placeholder: this.viewModel.placeholder,
                readonly: this.defineComputed(() => {
                    return !this.viewModel.isEnabled();
                })
            }
        });

        return this.jQueryControl;
    }

    protected onWidgetCreatedCallback(widget: kendo.ui.DateTimePickerExt): void {
        super.onWidgetCreatedCallback(widget);
        this.applyBindings(this.jQueryControl, {
            controlName: 'kendodateandtimepicker',

            autoLocator: this.viewModel.locator,

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        this.applyBindings(this.jQueryControl.find('.c-wrapper'), {
            invalid: this.viewModel.invalidationText,

            attr: {
                placeholder: this.viewModel.placeholder
            }
        });

        if (this.viewModel.linkDate != null) {
            this.viewModel.linkDate.onClick = () => {
                widget.open('date');
            };

            this.linkDate = new this.Link(this.viewModel.linkDate);
            let tuple = this.linkDate.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.linkTime != null) {
            this.viewModel.linkTime.onClick = () => {
                widget.open('time');
            };

            this.linkTime = new this.Link(this.viewModel.linkTime);
            let tuple = this.linkTime.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }
}

ComponentManager.setControl('KendoDateAndTimePicker', KendoDateAndTimePicker, 'RADPresentation.HTMLClient.DefaultViewExtensions');